export const roleCatalog = [
  { id: 'customer_admin', label: 'Customer Administrator', description: 'Full organization administration and Machine Intelligence access.' },
  { id: 'maintenance_manager', label: 'Maintenance Manager', description: 'Manage machines, documents, questions, and investigations.' },
  { id: 'technician', label: 'Technician / Engineer', description: 'Read and upload machine information, ask questions, and contribute to investigations.' },
  { id: 'viewer', label: 'Viewer', description: 'Read-only Machine Intelligence and investigations.' },
] as const;

export type RoleId = (typeof roleCatalog)[number]['id'];
export type MembershipStatus = 'INVITED' | 'ACTIVE' | 'SUSPENDED' | 'REMOVED';

export interface UserMembershipDto {
  membership_id: string;
  customer_id: string;
  user_id: string | null;
  email: string;
  status: MembershipStatus;
  role_ids: string[];
  effective_permissions: string[];
  facility_ids: string[];
  invited_by: string | null;
  invited_at: string | null;
  activated_at: string | null;
  updated_at: string | null;
}

export interface UserEntitlementsDto {
  plan_id?: string;
  plan_version?: number;
  display_name?: string;
  features?: string[];
  limits?: Record<string, number>;
}

export interface UserListResponseDto {
  customer: {
    customer_id: string;
    customer_name: string | null;
    status: string | null;
    entitlements: UserEntitlementsDto;
  };
  users: UserMembershipDto[];
  user_count: number;
  request_id?: string;
}

export interface InvitationResponseDto {
  membership: UserMembershipDto;
  identity: {
    status: string;
    invitation_requested: boolean;
    cognito_username: string | null;
    cognito_user_status: string | null;
  };
  notification?: {
    status: string;
    message_id?: string | null;
  } | null;
  idempotent: boolean;
  next_step: string;
  request_id?: string;
}

export interface MembershipResponseDto {
  membership: UserMembershipDto;
  idempotent?: boolean;
  request_id?: string;
}

export function roleLabel(roleId: string): string {
  return roleCatalog.find((role) => role.id === roleId)?.label ?? roleId;
}

export function statusLabel(status: MembershipStatus): string {
  return status === 'INVITED' ? 'Invited' : status === 'ACTIVE' ? 'Active' : status === 'SUSPENDED' ? 'Suspended' : 'Removed';
}
